import { useNow } from "@gigpro/ui/utils/useNow";
import { useQuery } from "@tanstack/react-query";
import { isAfter, isBefore } from "date-fns";
import type { PROfileExperienceProps } from "domains/pros/components/PROfileExperience";
import { experienceQuery } from "./queries";

const usePROfileExperience = ({ proId }: { proId: number }) => {
  const { data } = useQuery(experienceQuery({ id: proId }));
  const now = useNow();

  return data?.reduce<PROfileExperienceProps["data"]>(
    (acc, experience) => {
      const endDate = experience.end_date ?? now;
      acc.start_date = isBefore(experience.start_date, acc.start_date) ? experience.start_date : acc.start_date;
      acc.end_date = isAfter(endDate, acc.end_date) ? endDate : acc.end_date;
      if (experience.position_skill_object) {
        const byPosition = acc.by_position[experience.position_skill_object?.name] ?? {};
        byPosition[experience.business_name] = { start_date: experience.start_date, end_date: endDate };
        acc.by_position[experience.position_skill_object?.name] = byPosition;
      } else if (experience.position) {
        const byPosition = acc.by_position[experience.position] ?? {};
        byPosition[experience.business_name] = { start_date: experience.start_date, end_date: endDate };
        acc.by_position[experience.position] = byPosition;
      }
      return acc;
    },
    { start_date: now, end_date: new Date(0), by_position: {} },
  );
};

export { usePROfileExperience };
